import { AxiosResponse } from 'axios';

import api from 'utils/apiClient';
import { ISetting, ISettingsData, IUpdateSettingsData } from '../types/settings.types';

export const loadSettings = (): Promise<AxiosResponse<ISetting[]>> => {
  return api.get('/settings');
};

export const updateSettings = ({ data }: { data: ISettingsData }): Promise<AxiosResponse<IUpdateSettingsData>> => {
  return api.post('/settings/change', data);
};
